import { GridLayoutStyle, SpaceBetweenXType, SpaceBetweenYType } from '../types'

const TwoColumnSpacesBetween = (
    spaceBetween?: string
): {
    firstColumn: {
        spaceBetweenX: SpaceBetweenXType
        spaceBetweenY: SpaceBetweenYType
    }
    secondColumn: {
        spaceBetweenX: SpaceBetweenXType
    }
} => ({
    firstColumn: {
        spaceBetweenX: {
            small: {
                paddingRight: ['0px', '0px', '4px'],
            },
            standard: {
                paddingRight: ['0px', '0px', '8px'],
            },
            medium: {
                paddingRight: ['0px', '0px', '12px'],
            },
            big: {
                paddingRight: ['0px', '0px', '16px'],
            },
        },
        spaceBetweenY: {
            paddingBottom: spaceBetween ? [spaceBetween, spaceBetween, '0px'] : undefined,
        },
    },
    secondColumn: {
        spaceBetweenX: {
            small: {
                paddingLeft: ['0px', '0px', '4px'],
            },
            standard: {
                paddingLeft: ['0px', '0px', '8px'],
            },
            medium: {
                paddingLeft: ['0px', '0px', '12px'],
            },
            big: {
                paddingLeft: ['0px', '0px', '16px'],
            },
        },
    },
})

const getGridLayoutStyles = (spaceBetween?: string): GridLayoutStyle => ({
    '100': {
        firstColumnStyle: {
            width: '100%',
        },
        secondColumnStyle: {
            display: 'none',
        },
        thirdColumnStyle: {
            display: 'none',
        },
        fourthColumnStyle: {
            display: 'none',
        },
        hiddenColumnStyle: {
            display: 'none',
        },
    },
    '50-50': {
        firstColumnStyle: {
            width: ['100%', '100%', '50%'],
            ...TwoColumnSpacesBetween(spaceBetween).firstColumn,
        },
        secondColumnStyle: {
            width: ['100%', '100%', '50%'],
            ...TwoColumnSpacesBetween(spaceBetween).secondColumn,
        },
        thirdColumnStyle: {
            display: 'none',
        },
        fourthColumnStyle: {
            display: 'none',
        },
        hiddenColumnStyle: {
            display: 'none',
        },
    },
    '75-25': {
        firstColumnStyle: {
            width: ['100%', '100%', '66%', '75%'],
            ...TwoColumnSpacesBetween(spaceBetween).firstColumn,
        },
        secondColumnStyle: {
            width: ['100%', '100%', '34%', '25%'],
            ...TwoColumnSpacesBetween(spaceBetween).secondColumn,
        },
        thirdColumnStyle: {
            display: 'none',
        },
        fourthColumnStyle: {
            display: 'none',
        },
        hiddenColumnStyle: {
            display: 'none',
        },
    },
    '25-75': {
        firstColumnStyle: {
            width: ['100%', '100%', '34%', '25%'],
            ...TwoColumnSpacesBetween(spaceBetween).firstColumn,
        },
        secondColumnStyle: {
            width: ['100%', '100%', '66%', '75%'],
            ...TwoColumnSpacesBetween(spaceBetween).secondColumn,
        },
        thirdColumnStyle: {
            display: 'none',
        },
        fourthColumnStyle: {
            display: 'none',
        },
        hiddenColumnStyle: {
            display: 'none',
        },
    },
    '66-33': {
        firstColumnStyle: {
            width: ['100%', '100%', '66%'],
            ...TwoColumnSpacesBetween(spaceBetween).firstColumn,
        },
        secondColumnStyle: {
            width: ['100%', '100%', '34%'],
            ...TwoColumnSpacesBetween(spaceBetween).secondColumn,
        },
        thirdColumnStyle: {
            display: 'none',
        },
        fourthColumnStyle: {
            display: 'none',
        },
        hiddenColumnStyle: {
            display: 'none',
        },
    },
    '33-66': {
        firstColumnStyle: {
            width: ['100%', '100%', '34%'],
            ...TwoColumnSpacesBetween(spaceBetween).firstColumn,
        },
        secondColumnStyle: {
            width: ['100%', '100%', '66%'],
            ...TwoColumnSpacesBetween(spaceBetween).secondColumn,
        },
        thirdColumnStyle: {
            display: 'none',
        },
        fourthColumnStyle: {
            display: 'none',
        },
        hiddenColumnStyle: {
            display: 'none',
        },
    },
    '33-33-33': {
        flexWrap: ['wrap', 'wrap', 'nowrap'],
        firstColumnStyle: {
            width: ['100%', '100%', ''],
            spaceBetweenX: {
                small: {
                    paddingRight: ['0px', '0px', '5px'],
                },
                standard: {
                    paddingRight: ['0px', '0px', '11px'],
                },
                medium: {
                    paddingRight: ['0px', '0px', '16px'],
                },
                big: {
                    paddingRight: ['0px', '0px', '21px'],
                },
            },
            spaceBetweenY: {
                paddingBottom: spaceBetween ? [spaceBetween, spaceBetween, '0px'] : undefined,
            },
        },
        secondColumnStyle: {
            width: ['100%', '100%', ''],
            spaceBetweenX: {
                small: {
                    paddingLeft: ['0px', '0px', '3px'],
                    paddingRight: ['0px', '0px', '3px'],
                },
                standard: {
                    paddingLeft: ['0px', '0px', '5px'],
                    paddingRight: ['0px', '0px', '5px'],
                },
                medium: {
                    paddingLeft: ['0px', '0px', '8px'],
                    paddingRight: ['0px', '0px', '8px'],
                },
                big: {
                    paddingLeft: ['0px', '0px', '11px'],
                    paddingRight: ['0px', '0px', '11px'],
                },
            },
            spaceBetweenY: {
                paddingBottom: spaceBetween ? [spaceBetween, spaceBetween, '0px'] : undefined,
            },
        },
        thirdColumnStyle: {
            width: ['100%', '100%', ''],
            spaceBetweenX: {
                small: {
                    paddingLeft: ['0px', '0px', '5px'],
                },
                standard: {
                    paddingLeft: ['0px', '0px', '11px'],
                },
                medium: {
                    paddingLeft: ['0px', '0px', '16px'],
                },
                big: {
                    paddingLeft: ['0px', '0px', '21px'],
                },
            },
        },
        fourthColumnStyle: {
            display: 'none',
        },
        hiddenColumnStyle: {
            display: 'none',
        },
    },
    '25-25-25-25': {
        firstColumnStyle: {
            width: ['100%', '100%', '33%', '25%'],
            spaceBetweenX: {
                small: {
                    paddingRight: ['0px', '0px', '5px', '6px'],
                },
                standard: {
                    paddingRight: ['0px', '0px', '11px', '12px'],
                },
                medium: {
                    paddingRight: ['0px', '0px', '16px', '18px'],
                },
                big: {
                    paddingRight: ['0px', '0px', '21px', '24px'],
                },
            },
            spaceBetweenY: {
                paddingBottom: spaceBetween
                    ? [spaceBetween, spaceBetween, spaceBetween, '0px']
                    : undefined,
            },
        },
        secondColumnStyle: {
            width: ['100%', '100%', '34%', '25%'],
            spaceBetweenX: {
                small: {
                    paddingLeft: ['0px', '0px', '3px', '2px'],
                    paddingRight: ['0px', '0px', '3px', '4px'],
                },
                standard: {
                    paddingLeft: ['0px', '0px', '5px', '4px'],
                    paddingRight: ['0px', '0px', '5px', '8px'],
                },
                medium: {
                    paddingLeft: ['0px', '0px', '8px', '6px'],
                    paddingRight: ['0px', '0px', '8px', '12px'],
                },
                big: {
                    paddingLeft: ['0px', '0px', '11px', '8px'],
                    paddingRight: ['0px', '0px', '11px', '16px'],
                },
            },
            spaceBetweenY: {
                paddingBottom: spaceBetween ? [spaceBetween, spaceBetween, '0px'] : undefined,
            },
        },
        thirdColumnStyle: {
            width: ['100%', '100%', '33%', '25%'],
            spaceBetweenX: {
                small: {
                    paddingLeft: ['0px', '0px', '5px', '4px'],
                    paddingRight: ['0px', '0px', '0px', '2px'],
                },
                standard: {
                    paddingLeft: ['0px', '0px', '11px', '8px'],
                    paddingRight: ['0px', '0px', '0px', '4px'],
                },
                medium: {
                    paddingLeft: ['0px', '0px', '16px', '12px'],
                    paddingRight: ['0px', '0px', '0px', '6px'],
                },
                big: {
                    paddingLeft: ['0px', '0px', '21px', '16px'],
                    paddingRight: ['0px', '0px', '0px', '8px'],
                },
            },
            spaceBetweenY: {
                paddingBottom: spaceBetween ? [spaceBetween, spaceBetween, '0px'] : undefined,
            },
        },
        fourthColumnStyle: {
            width: ['100%', '100%', '33%', '25%'],
            spaceBetweenX: {
                small: {
                    paddingLeft: ['0px', '0px', '0px', '6px'],
                    paddingRight: ['0px', '0px', '5px', '0px'],
                },
                standard: {
                    paddingLeft: ['0px', '0px', '0px', '12px'],
                    paddingRight: ['0px', '0px', '11px', '0px'],
                },
                medium: {
                    paddingLeft: ['0px', '0px', '0px', '18px'],
                    paddingRight: ['0px', '0px', '18px', '0px'],
                },
                big: {
                    paddingLeft: ['0px', '0px', '0px', '24px'],
                    paddingRight: ['0px', '0px', '21px', '0px'],
                },
            },
        },
        hiddenColumnStyle: {
            display: ['none', 'none', undefined, 'none'],
            width: ['100%', '100%', '67%', '100%'],
        },
    },
})

export default getGridLayoutStyles
